import React, { useEffect, useState } from "react";
import AccountForm from "./AccountForm";
import { apiCall } from "../utils/Api";
import { Form, Input, Button, Divider, Checkbox, Spin, Select } from 'antd';
import { useSession } from "../utils/Session";
import { useHistory } from "react-router-dom";
import { ExclamationCircleFilled } from '@ant-design/icons';
import { useForm } from "antd/lib/form/Form";


function AccountCreate() {


    const [session, setSession] = useSession();
    const [error, setError] = useState(false);
    const [errorMsg, setErrorMsg] = useState();

    /**
    * API Call to pass the form data and create the account
    */
    const history = useHistory();
    const { email_address } = session.user;



    const [loading, setLoading] = useState(true);



    const [defaultLocation, setDefaultLocation] = useState({
        country: "",
        province: ""
    });

    const getDefaultLocation = () => {

        if (!session.user.hasOwnProperty("email_address")) {
            // refreshed so redirect
            history.push("/account/signup")
        }

        let _country = "";
        let _province = window.sitesettings.store_info.province;

        switch (window.sitesettings.store_info.iso3166_2_country) {
            case "CA":
                _country = "Canada"
                break;
            case "US":
                _country = "United States"
                break;
            case "MX":
                _country = "Mexico"
                break;
            default:
                _country = ""
                break;
        }


        if (_country) {
            apiCall("province/get", { country: _country, province: _province }, (_status, _result) => {
                if (_status) {
                    setDefaultLocation({ country: _country, province: _result.province })
                }
                setLoading(false);
            })
        } else {
            setLoading(false);
        }

    }

    useEffect(getDefaultLocation, []);

    const onCreateAccount = (_status, _result) => {

        if (_status) {
            // set session
            if (history.location.hasOwnProperty("state") && history.location.state.hasOwnProperty("validation_required") && history.location.state.validation_required) {
                history.push({ "pathname": "/account/verify", "state": _result });
            } else {
                setSession(_result);
                
                history.push({ "pathname": "/account/finished" });
            }

        } else {
            setError(true);
            setErrorMsg(_result.error);
        }
    }

    /**
    * API Call to pass the form data and create the account
    * @param {object} form
    */
    const createAccount = (_form) => {

        let _extra = {};
        if (_form["confirm"]) {
            delete _form["confirm"];
        }

        if (_form["aext"]) {
            _form["alt_phone_number_ext"] = _form["aext"];
            delete _form["aext"];
        }

        if (_form["comprole"]) {
            _extra.comprole = _form["comprole"];
        }

        if (_form["emprole"]) {
            _extra.emprole = _form["emprole"];
        }

        if (_form["acctreason"]) {
            _extra.acctreason = _form["acctreason"];
        }

        _form["account_extra_fields"] = JSON.stringify(_extra);

        // if (window.sitesettings.account_extra_fields.length > 0) {
        //     let obj = {};
        //     for (let i = 0; i < window.sitesettings.account_extra_fields.length; i++) {
        //         obj[window.sitesettings.account_extra_fields[i]] = _form[window.sitesettings.account_extra_fields[i]];
        //         delete _form[window.sitesettings.account_extra_fields[i]];
        //     }
        //     _form["account_extra_fields"] = JSON.stringify(obj);
        // }


        if (history.location.hasOwnProperty("state")) {
            if (history.location.state.hasOwnProperty("token")) {
                if (history.location.state.token) {
                    delete _form["email_address"];
                    _form["token"] = history.location.state.token;
                }
            }
        }

        
        apiCall("account/create", _form, onCreateAccount);
    }



    /**
    * Augments form with email address from signup. 
    * - If there is no email in the session, return to signup
    * - Email is hidden as it's a requirement for the API, but since it's already valid - we don't want the user to edit
    * @returns {jsx} email address from signup.
    */
    const displayHiddenEmail = () => {


        if (!history) {
            if (!email_address && !history.location.state.token) {
                history.push({ "pathname": "/account/signup" });
            }
        }



        return (
            <Form.Item label="Email address" name="email_address" initialValue={email_address}  >
                <Input aria-label="Email Address" disabled autoComplete="off" />
            </Form.Item>
        );


    }

    /**
    * Augments form with password / confirm form fields 
    *  - Validates 8 character minimum
    *  - Validates the Password / Confirm form fields match
    * @returns {jsx} password and confirm form fields
    */
    const displayConfirmPassword = () => {

        return (
            <>
                <Form.Item
                    name="password"
                    label="Password"
                    rules={[{
                        required: true,
                        min: 8,
                        message: 'Password must be at least 8 characters.',
                    },]}
                    hasFeedback
                >
                    <Input.Password aria-label="Password" placeholder="Password" />
                </Form.Item>

                <Form.Item
                    name="confirm"
                    label="Confirm password"
                    dependencies={['password']}
                    hasFeedback
                    rules={[{
                        required: true,
                        message: 'Please confirm your password.',
                    }, ({ getFieldValue }) => ({
                        validator(rule, value) {

                            if (value.length < 8) {
                                return Promise.reject('Password must be at least 8 characters.');
                            }

                            if (!value || getFieldValue('password') === value) {
                                return Promise.resolve();
                            }
                            return Promise.reject('The two passwords that you entered do not match.');
                        },
                    }),]}
                >
                    <Input.Password aria-label="Confirm Password" placeholder="Confirm password" min={8} max={12} />
                </Form.Item>
            </>
        )

    }

    const comproleOptions = [
        "Bookstore",
        "Distributor",
        "Other Retail",
        "Publisher",
        "Sales & Marketing",
        "Small Press",
        "Wholesaler",
        "Library",
        "Other Book Industry Professional",
    ];

    const emproleOptions = [
        "Accounting",
        "Employee",
        "Managment",
        "Sales & Marketing",
    ]



    const drawExtra = () => {


        return (
            <>
                <Form.Item name={"comprole"} label={"Your company's primary role"} >
                    <Select aria-label="Company's primary role" showSearch placeholder="Select..." style={{ maxWidth: 400 }}>
                        {comproleOptions.map((role) => (
                            <Select.Option key={role} value={role}>
                                {role}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>
                <Form.Item name={"emprole"} label={"Your role with the company"} >
                    <Select aria-label="Your role with the company" showSearch placeholder="Select..." style={{ maxWidth: 400 }}>
                        {emproleOptions.map((role) => (
                            <Select.Option key={role} value={role}>
                                {role}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>
                <Form.Item name={"acctreason"} label={"Please tell us briefly why you need an account with Bookmanager"}>
                    <Input.TextArea rows={5} placeholder="Enter your message here..."></Input.TextArea>
                </Form.Item>
            </>
        )

    }

    const [createForm] = useForm();


    const AcceptTerms = (props) => {

        const [showWarning, setShowWarning] = useState(window?.sitesettings?.checkout_info?.terms_consent_enabled)

        if (window?.sitesettings?.checkout_info?.terms_consent_enabled) {
            return (
                <div className="float-flex">
                    <div><Checkbox onChange={(e) => setShowWarning(!e.target.checked)}><p style={{ "fontSize": "13px" }}><nobr>I accept the <a href="/terms-conditions" aria-label="Terms & Conditions (opens in a new tab)" target="_blank" title="Terms & Conditions" style={{ "color": "#069" }}>Terms & Conditions</a>.</nobr></p></Checkbox></div>
                    <div>
                        <Spin spinning={showWarning} indicator={<></>}>
                            {props.children}
                        </Spin>
                    </div>
                </div>
            )
        } else {
            return props.children;
        }

    }


    const display = () => {




        return (
            <>

                <div style={{ "maxWidth": "500px", "margin": "0 auto" }}>
                    <h2>Account Details</h2>
                    <div aria-hidden><Divider /></div>
                    <Form form={createForm} validateTrigger={['onChange', 'onBlur']} size="large" onFinish={(_form) => createAccount(_form)} layout="vertical">
                        {displayHiddenEmail()}

                        {displayConfirmPassword()}

                        <div aria-hidden><Divider /></div>
                        {<AccountForm user={{ country: defaultLocation.country }} create form={createForm} />}

                        {drawExtra()}
                        {(error && <> <div aria-hidden><Divider /></div><p style={{ "paddingBottom": "15px", "color": "#ff4d4f", "textAlign": "center" }} className="error"><ExclamationCircleFilled /> {errorMsg}</p></>)}


                        <div aria-hidden><Divider /></div>
                        <AcceptTerms>
                            <Button type="primary" htmlType="submit">Create Account</Button>
                        </AcceptTerms>
                    </Form>
                </div>
            </>
        )

    }

    /**
    * Displays the jsx for the form
    * @returns {jsx} jsx for the form
    */

    if (loading) {
        return (<></>)
    }
    return display();


}

export default AccountCreate;